import React from 'react';
import GoogleChart from 'tuc-webui-base/components/GoogleChart';
import GraphTile from './GraphTile';

const withTile = (Component, options = {}) => {
  return (props) => {
    return <GraphTile {...options} {...props} Component={Component} />;
  };
};

const withChartTile = (Component, options = {}) => {
  const ChartComponent = Component || GoogleChart;
  const { createChartModel, ...opts } = options;
  return (props) => {
    return <GraphTile {...opts} {...props} computeData={createChartModel} Component={ChartComponent} />;
  };
};

export { withTile, withChartTile };
